// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__gV42P","fileBtn":"File_fileBtn__3hXTG","closeBtn":"File_closeBtn__1YxMZ","fileSelected":"File_fileSelected__VtT6r","disabled":"File_disabled__38uHj"};